import dynamic from "next/dynamic";
const SideBySideParagraphAndTagsHomepageFirstFoldComponent = dynamic(()=>import("./side-by-side-paragraph-and-tags-homepage-first-fold-component"));
import SideBySideParagraphAndTagsHomepageFirstFoldConfig from "./side-by-side-paragraph-and-tags-homepage-first-fold-config";
import SideBySideParagraphAndTagsHomepageFirstFoldAdvancedConfig from "./side-by-side-paragraph-and-tags-homepage-first-fold-advanced-config";
export default {
    SideBySideParagraphAndTagsHomepageFirstFoldComponent,
    SideBySideParagraphAndTagsHomepageFirstFoldConfig,
    SideBySideParagraphAndTagsHomepageFirstFoldAdvancedConfig
};
